export default __webpack_public_path__ + "static/media/3077.5805b3eb.jpg";